<template>
  <div>
    <v-container fluid>
      <Govem_bar />

      <!-- การ์ดหลัก -->
      <base-material-card
        icon="mdi-clipboard-text"
        title="พนักงานราชการ (เกี่ยวข้องกับระบบการย้าย)"
        class="px-5 py-3"
      >
        <!-- ส่วนหัวและปุ่มดำเนินการ -->
        <HeaderSection
          @add-personnel="openAddDialog"
          @export-data="exportData"
          :collegeCode="user.user_code"
        />

        <!-- ตารางคำขอย้าย -->
        <TransferRequestTable
          :items="collegepersonnelreqs"
          :loading="loading"
          @cancel-request="handleCancelRequest"
        />

        <!-- ตารางแจ้งปรับปรุงข้อมูล -->
        <NotificationTable
          :items="personnel_temporarysNoticesQu"
          @delete-notification="handleDeleteNotification"
        />

        <!-- ตารางข้อมูลพนักงานราชการ -->
        <PersonnelDataTable
          :items="personnel_temporarys"
          :headers="showHeaders"
          :loading="loading"
          :search.sync="search"
          :selected-headers.sync="selectedHeaders"
          :all-headers="headers"
          @edit-personnel="openEditDialog"
          @notify-update="openNotifyDialog"
          @view-contract="viewContract"
        />
      </base-material-card>

      <!-- Dialog สำหรับเพิ่มพนักงาน -->
      <AddPersonnelDialog
        v-model="dialogs.add"
        :personnel-data.sync="forms.add"
        :positions="j18idPositions"
        :personnel-check="personnelCheck"
        @submit="handleAddSubmit"
        @search="searchPersonnel"
      />

      <!-- Dialog สำหรับแก้ไขข้อมูล -->
      <EditPersonnelDialog
        v-model="dialogs.edit"
        :personnel-data.sync="forms.edit"
        :branches="branch"
        :education-types="pt_ed_AppTypes"
        @submit="handleEditSubmit"
        @delete-license="handleDeleteLicense"
        @view-pdf="handleViewPdf"
      />

      <!-- Dialog แจ้งปรับปรุงข้อมูล -->
      <NotifyDialog
        v-model="dialogs.notify"
        :personnel-info="personnelForNotify"
        :notification-data.sync="forms.notify"
        @submit="handleNotifySubmit"
      />

      <!-- Dialog แสดง PDF -->
      <PdfViewerDialog
        v-model="dialogs.pdfViewer"
        :pdf-url="currentPdfUrl"
        :pdf-type="currentPdfType"
      />

      <!-- Snackbar แจ้งเตือน -->
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">
            ปิด
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import Govem_bar from "../../../components/college/govem_bar.vue";
import HeaderSection from "../../../components/HeaderSection.vue";
import TransferRequestTable from "../../../components/TransferRequestTable.vue";
import NotificationTable from "../../../components/NotificationTable.vue";
import PersonnelDataTable from "../../../components/PersonnelDataTable.vue";
import AddPersonnelDialog from "../../../components/AddPersonnelDialog.vue";
import EditPersonnelDialog from "../../../components/EditPersonnelDialog.vue";
import NotifyDialog from "../../../components/NotifyDialog.vue";
import PdfViewerDialog from "../../../components/PdfViewerDialog.vue";

export default {
  name: "GovernmentEmployeePage",

  components: {
    Govem_bar,
    HeaderSection,
    TransferRequestTable,
    NotificationTable,
    PersonnelDataTable,
    AddPersonnelDialog,
    EditPersonnelDialog,
    NotifyDialog,
    PdfViewerDialog
  },

  data() {
    return {
      // Configuration
      ApiKey: "HRvec2021",

      // Loading States
      loading: true,

      // User Data
      user: {},

      // Dialog States
      dialogs: {
        add: false,
        edit: false,
        notify: false,
        pdfViewer: false
      },

      // Form Data
      forms: {
        add: {},
        edit: {},
        notify: {}
      },

      // Table Data
      personnel_temporarys: [],
      collegepersonnelreqs: [],
      personnel_temporarysNoticesQu: [],

      // Search & Filter
      search: "",
      selectedHeaders: [],
      headers: [],

      // Reference Data
      j18idPositions: [],
      branch: [],
      pt_ed_AppTypes: [
        { text: "ปริญญาตรี หลักสูตร 4 ปี", value: "ปริญญาตรี หลักสูตร 4 ปี" },
        { text: "ปริญญาตรี หลักสูตร 5 ปี", value: "ปริญญาตรี หลักสูตร 5 ปี" },
        {
          text:
            "ประกาศนียบัตรบัณฑิต หลักสูตรไม่น้อยกว่า 1 ปี ต่อจาก ป.ตรี 4 ปี",
          value:
            "ประกาศนียบัตรบัณฑิต หลักสูตรไม่น้อยกว่า 1 ปี ต่อจาก ป.ตรี 4 ปี"
        },
        { text: "ปริญญาตรี หลักสูตร 6 ปี", value: "ปริญญาตรี หลักสูตร 6 ปี" },
        { text: "อื่นๆ", value: "อื่นๆ" }
      ],

      // Temporary Data
      personnelCheck: {},
      personnelForNotify: {},

      // PDF Viewer
      currentPdfUrl: "",
      currentPdfType: "",

      // Snackbar
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },

      // Headers Definition
      headersMap: [
        {
          text: "ดำเนินการ",
          align: "center",
          value: "actions_update",
          icon: "mdi-file-document-edit"
        },
        {
          text: "แก้ไข",
          align: "center",
          value: "actions",
          icon: "mdi-file-document-edit"
        },
        {
          text: "แจ้งปรับปรุงข้อมูล",
          align: "center",
          value: "actionNotices",
          icon: "mdi-file-document-edit"
        },
        {
          text: "ดูประวัติ",
          align: "center",
          value: "viewId",
          icon: "mdi-file-document-edit"
        },
        {
          text: "สัญญาจ้าง",
          align: "center",
          value: "govem_contract",
          icon: "mdi-file-document-edit"
        },
        { text: "รหัสบัตรประชาชน", align: "left", value: "id_card" },
        { text: "ชื่อ-นามสกุล", align: "left", value: "frist_names" },
        { text: "ตำแหน่ง", align: "center", value: "name_postion" },
        { text: "เลขที่ตำแหน่ง", align: "center", value: "id_position" },
        { text: "ประเภท", align: "center", value: "type_position" },
        { text: "วุฒิการศึกษา", align: "center", value: "ed_abb" },
        { text: "สาขาวิชา", align: "center", value: "ed_name" },
        { text: "วันเดือนปีเกิด", align: "center", value: "brith_day" },
        { text: "วันเดือนปีบรรจุ", align: "center", value: "date_app2" },
        { text: "คำสั่งที่", align: "center", value: "detail_order" },
        { text: "วันที่เริ่มสัญญา", align: "center", value: "date_app_now" },
        { text: "วันที่สิ้นสุดสัญญา", align: "center", value: "date_end_govem" }
      ]
    };
  },
  async created() {
    this.initializeHeaders();
  },

  async mounted() {
    await this.initializePage();
  },
  computed: {
    showHeaders() {
      return this.headers.filter(h => this.selectedHeaders.includes(h));
    },

    currentDate() {
      return new Date().toISOString().substr(0, 10);
    },

    currentDateThai() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear() + 543;
      const time = `${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
      return `${dd}/${mm}/${yyyy}/${time}`;
    }
  },
  methods: {
    // ==================== Initialization ====================
    initializeHeaders() {
      this.headers = Object.values(this.headersMap);
      this.selectedHeaders = this.headers;
    },

    async initializePage() {
      try {
        this.showLoading();

        // โหลดข้อมูลผู้ใช้
        await this.loadUserData();

        // โหลดข้อมูลหลัก
        await Promise.all([
          this.loadPersonnelData(),
          this.loadTransferRequests(),
          this.loadNotifications(),
          this.loadPositions(),
          this.loadBranches()
        ]);

        this.hideLoading();
      } catch (error) {
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
        console.error(error);
      }
    },

    async loadUserData() {
      const userSession = JSON.parse(localStorage.getItem("user")) || {};
      const response = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user = response.data;
    },
    // ==================== Data Loading ====================
    async loadPersonnelData() {
      this.loading = true;
      try {
        const response = await this.$http.post(
          "personnel_temporary_govem.php",
          {
            ApiKey: this.ApiKey,
            user_code: this.user.user_name,
            user_status: "gov_em"
          }
        );
        this.personnel_temporarys = response.data;
      } catch (error) {
        this.showError("ไม่สามารถโหลดข้อมูลพนักงานได้");
      } finally {
        this.loading = false;
      }
    },

    async loadTransferRequests() {
      try {
        const response = await this.$http.post("collegepersonnelreq.php", {
          ApiKey: this.ApiKey,
          collegeNewReq: this.user.user_name
        });
        this.collegepersonnelreqs = response.data;
      } catch (error) {
        this.showError("ไม่สามารถโหลดคำขอย้ายได้");
      }
    },

    async loadNotifications() {
      try {
        const response = await this.$http.post(
          "personnel_temporary_notify.php",
          {
            ApiKey: this.ApiKey,
            personnel_temporary_notifyCollegeCode: this.user.user_code
          }
        );
        this.personnel_temporarysNoticesQu = response.data;
      } catch (error) {
        this.showError("ไม่สามารถโหลดการแจ้งเตือนได้");
      }
    },

    async loadPositions() {
      try {
        const response = await this.$http.post("jor18.php", {
          ApiKey: this.ApiKey,
          j18college_code: this.user.user_code
        });
        this.j18idPositions = response.data;
      } catch (error) {
        this.showError("ไม่สามารถโหลดตำแหน่งได้");
      }
    },

    async loadBranches() {
      try {
        const response = await this.$http.post("branch.php", {
          ApiKey: this.ApiKey
        });
        this.branch = response.data;
      } catch (error) {
        this.showError("ไม่สามารถโหลดสาขาวิชาได้");
      }
    },
    // ==================== Dialog Handlers ====================
    openAddDialog() {
      this.forms.add = {};
      this.personnelCheck = {};
      this.dialogs.add = true;
    },

    async openEditDialog(idCard) {
      try {
        const response = await this.$http.post(
          "personnel_temporary_govem.php",
          {
            ApiKey: this.ApiKey,
            id_card: idCard
          }
        );
        this.forms.edit = response.data;
        this.forms.edit.p_word = "";
        this.dialogs.edit = true;
      } catch (error) {
        this.showError("ไม่สามารถโหลดข้อมูลพนักงานได้");
      }
    },

    async openNotifyDialog(idCard) {
      try {
        const response = await this.$http.post(
          "personnel_temporary_govem.php",
          {
            ApiKey: this.ApiKey,
            id_card: idCard
          }
        );
        this.personnelForNotify = response.data;
        this.forms.notify = {};
        this.dialogs.notify = true;
      } catch (error) {
        this.showError("ไม่สามารถโหลดข้อมูลได้");
      }
    },
    // ==================== Form Submissions ====================
    async handleAddSubmit() {
      try {
        const confirmed = await this.confirmAction(
          `ยืนยันการเพิ่มพนักงาน`,
          this.personnelCheck.frist_names
        );

        if (!confirmed) return;

        const data = {
          ...this.forms.add,
          ApiKey: this.ApiKey,
          collegeNewReq: this.user.user_code,
          collegeOleCode: this.personnelCheck.college_code,
          collegeRegDatetime: this.currentDateThai,
          collegeRegStatus: "req"
        };

        const response = await this.$http.post(
          "collegepersonnelreq.insert.php",
          data
        );

        if (response.data.status) {
          await this.logAction(
            "insert",
            "collegepersonnelreq",
            data.personalIDcardReq
          );
          this.showSuccess("บันทึกข้อมูลเรียบร้อย");
          await this.loadTransferRequests();
          this.dialogs.add = false;
        } else {
          this.showError("ไม่สามารถบันทึกข้อมูลได้");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
        console.error(error);
      }
    },

    async handleEditSubmit(uploadFiles) {
      try {
        const confirmed = await this.confirmAction(
          "ยืนยันการแก้ไขข้อมูล",
          this.forms.edit.frist_names
        );

        if (!confirmed) return;

        // ✅ ส่งไฟล์ไปที่ handleFileUploads
        await this.handleFileUploads(uploadFiles);

        const response = await this.$http.post(
          "personnel_temporary.update.admin.php",
          { ...this.forms.edit, ApiKey: this.ApiKey }
        );

        if (response.data.status) {
          await this.logAction(
            "update",
            "personnel_temporary",
            this.forms.edit.id_card
          );
          this.showSuccess("แก้ไขข้อมูลเรียบร้อย");
          await this.loadPersonnelData();
          this.dialogs.edit = false;
        } else {
          this.showError("ไม่สามารถแก้ไขข้อมูลได้");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
        console.error(error);
      }
    },

    async handleNotifySubmit() {
      try {
        const confirmed = await this.confirmAction(
          "ยืนยันการแจ้งปรับปรุงข้อมูล",
          this.personnelForNotify.frist_names
        );

        if (!confirmed) return;

        const data = {
          ...this.forms.notify,
          ApiKey: this.ApiKey,
          personnel_temporary_notifyCollegeCode: this.personnelForNotify
            .college_code,
          personnel_temporary_notify_IDcard: this.personnelForNotify.id_card,
          personnel_temporary_notifyStatus: "send",
          personnel_temporary_notifyDateTIme: this.currentDateThai
        };

        const response = await this.$http.post(
          "personnel_temporary_notify.insert.php",
          data
        );

        if (response.data.status) {
          await this.logAction(
            "insert",
            "personnel_temporary_notify",
            data.personnel_temporary_notify_IDcard
          );
          await this.sendLineNotification(data);
          this.showSuccess("แจ้งปรับปรุงข้อมูลเรียบร้อย");
          await this.loadNotifications();
          this.dialogs.notify = false;
        } else {
          this.showError("ไม่สามารถแจ้งปรับปรุงข้อมูลได้");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
        console.error(error);
      }
    },
    // ==================== Delete Actions ====================
    async handleCancelRequest(personalIDcardReq) {
      try {
        const response = await this.$http.post("collegepersonnelreq.php", {
          ApiKey: this.ApiKey,
          personalIDcardReq
        });

        const confirmed = await this.confirmAction(
          "ยกเลิกคำขอย้าย",
          response.data.frist_names
        );

        if (!confirmed) return;

        const deleteResponse = await this.$http.post(
          "collegepersonnelreq.delete.php",
          {
            ApiKey: this.ApiKey,
            personalIDcardReq
          }
        );

        if (deleteResponse.data.status) {
          await this.logAction(
            "delete",
            "collegepersonnelreq",
            personalIDcardReq
          );
          this.showSuccess("ยกเลิกคำขอเรียบร้อย");
          await Promise.all([
            this.loadPersonnelData(),
            this.loadTransferRequests()
          ]);
        } else {
          this.showError("ไม่สามารถยกเลิกคำขอได้");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
        console.error(error);
      }
    },

    async handleDeleteNotification(notificationId) {
      try {
        const response = await this.$http.post(
          "personnel_temporary_notify.php",
          {
            ApiKey: this.ApiKey,
            personnel_temporary_notifyID: notificationId
          }
        );

        const confirmed = await this.confirmAction(
          "ยกเลิกรายการแจ้งเตือน",
          response.data.frist_names
        );

        if (!confirmed) return;

        const deleteResponse = await this.$http.post(
          "personnel_temporary_notify.delete.php",
          {
            ApiKey: this.ApiKey,
            personnel_temporary_notifyID: notificationId
          }
        );

        if (deleteResponse.data.status) {
          await this.logAction(
            "delete",
            "personnel_temporary_notify",
            notificationId
          );
          this.showSuccess("ยกเลิกรายการเรียบร้อย");
          await this.loadNotifications();
        } else {
          this.showError("ไม่สามารถยกเลิกรายการได้");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
        console.error(error);
      }
    },

    async handleDeleteLicense(type) {
      const fileMapping = {
        teach: {
          path: "../HRvecLicenseTeach/",
          field: "pt_licence_file"
        },
        director: {
          path: "../HRvecLicenseDirector/",
          field: "pt_licencedr_file"
        },
        contract: {
          path: "../HRemployee_contract/",
          field: "govem_contract"
        }
      };

      const mapping = fileMapping[type];
      if (!mapping) return;

      try {
        const confirmed = await this.confirmAction("ยืนยันการลบไฟล์", "");
        if (!confirmed) return;

        await this.$http.post("deletefile.php", {
          ApiKey: this.ApiKey,
          filename: mapping.path + this.forms.edit[mapping.field]
        });

        const updateData = {
          ApiKey: this.ApiKey,
          id_card: this.forms.edit.id_card,
          [mapping.field]: ""
        };

        const response = await this.$http.post(
          "personnel_temporary.update.php",
          updateData
        );

        if (response.data.status) {
          this.showSuccess("ลบไฟล์เรียบร้อย");
          await this.loadPersonnelData();
          await this.openEditDialog(this.forms.edit.id_card);
        } else {
          this.showError("ไม่สามารถลบไฟล์ได้");
        }
      } catch (error) {
        this.showError("เกิดข้อผิดพลาด");
        console.error(error);
      }
    },
    // ==================== File & PDF Handlers ====================
    async handleFileUploads(uploadFiles) {
      const fileMapping = {
        contract: {
          file: uploadFiles.contract,
          path: "HRemployee_contract",
          field: "govem_contract",
          suffix: "contract.pdf"
        },
        teach: {
          file: uploadFiles.teach,
          path: "HRvecLicenseTeach",
          field: "pt_licence_file",
          suffix: "teach.pdf"
        },
        director: {
          file: uploadFiles.director,
          path: "HRvecLicenseDirector",
          field: "pt_licencedr_file",
          suffix: "dr.pdf"
        }
      };

      for (const [key, config] of Object.entries(fileMapping)) {
        if (config.file) {
          const filename = `${this.forms.edit.id_card}_${Date.now()}_${
            config.suffix
          }`;
          const uploadSuccess = await this.uploadFile(
            config.file,
            config.path,
            filename
          );

          if (uploadSuccess) {
            this.forms.edit[config.field] = filename;
          } else {
            throw new Error(`ไม่สามารถอัปโหลดไฟล์ ${key} ได้`);
          }
        }
      }
    },

    // personnel_govem.vue

async uploadFile(file, path, filename) {
  try {
    const formData = new FormData();
    formData.append("ApiKey", this.ApiKey);
    formData.append("file", file);
    // ✅ แก้ไข: Backend ของคุณใช้ $_POST['filename'] ในการสร้าง path
    // ดังนั้นต้องส่ง path + filename ไปในตัวแปร filename
    formData.append("filename", `../${path}/${filename}`); 

    const response = await this.$http.post("uploadfile.php", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    return response.data.status === true;
  } catch (error) {
    console.error("Upload error:", error);
    return false;
  }
},
    handleViewPdf(type) {
      const pdfMapping = {
        teach: `/HRvecLicenseTeach/${this.forms.edit.pt_licence_file}`,
        director: `/HRvecLicenseDirector/${this.forms.edit.pt_licencedr_file}`
      };

      this.currentPdfUrl = pdfMapping[type];
      this.currentPdfType = type;
      this.dialogs.pdfViewer = true;
    },

    viewContract(contractFile) {
      this.currentPdfUrl = `https://hrvec.ovec.go.th/HRemployee_contract/${contractFile}`;
      this.currentPdfType = "contract";
      this.dialogs.pdfViewer = true;
    },
    // ==================== Search & Export ====================
    async searchPersonnel() {
      try {
        const response = await this.$http.post(
          "personnel_temporary_govem.php",
          {
            ApiKey: this.ApiKey,
            id_card: this.forms.add.personalIDcardReq,
            user_status: "gov_em"
          }
        );
        this.personnelCheck = response.data;
      } catch (error) {
        this.showError("ไม่พบข้อมูลพนักงาน");
      }
    },

    exportData() {
      window.open(
        `/college/print_personnel_license/?cid=${this.user.user_code}`,
        "_blank"
      );
    },
    // ==================== Utilities ====================
    async logAction(event, page, detail) {
      const userSession = JSON.parse(localStorage.getItem("user")) || {};
      await this.$http.post("data_syslog.insert.php", {
        ApiKey: this.ApiKey,
        user_account: userSession.user_name,
        event_log: event,
        page_log: page,
        table_log: `${page}.${event}`,
        detail_log: detail,
        date_times: this.currentDateThai
      });
    },

    async sendLineNotification(data) {
      await this.$http.post("linenotify_hr.php", {
        ApiKey: this.ApiKey,
        college_name: this.user.college_name,
        details: `งานบุคคล : แจ้งแก้ไข ${data.personnel_temporary_notify_IDcard}`,
        datetime: this.currentDate
      });
    },

    async confirmAction(title, text) {
      const result = await Swal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      return result.isConfirmed;
    },

    showSuccess(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showError(message) {
      Swal.fire({
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showLoading() {
      Swal.fire({
        title: "กรุณารอสักครู่...",
        timerProgressBar: true,
        didOpen: () => Swal.showLoading(),
        allowOutsideClick: false
      });
    },

    hideLoading() {
      Swal.close();
    }
  }
};
</script>
<style scoped>
/* ==================== ตาราง ==================== */
.my-header-style {
  background: #f8bbd0;
  color: white;
}

/* ==================== Dialog ==================== */
.dialog-card {
  border-radius: 8px;
}

/* ==================== ปุ่ม ==================== */
.action-button {
  margin: 0 4px;
}

.action-button-group {
  display: flex;
  gap: 8px;
  justify-content: center;
}

/* ==================== ฟอร์ม ==================== */
.form-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.form-section-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 12px;
  color: #1976d2;
}

/* ==================== Card ==================== */
.info-card {
  border-left: 4px solid #1976d2;
  background-color: #f5f5f5;
}

/* ==================== Responsive ==================== */
@media (max-width: 960px) {
  .action-button-group {
    flex-direction: column;
  }

  .action-button {
    width: 100%;
    margin: 4px 0;
  }
}

/* ==================== Loading ==================== */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* ==================== Animations ==================== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ==================== PDF Viewer ==================== */
.pdf-container {
  width: 100%;
  height: 700px;
  border: 1px solid #e0e0e0;
}

/* ==================== Status Chips ==================== */
.status-chip {
  font-weight: 500;
}

.status-chip--pending {
  background-color: #ff9800 !important;
}

.status-chip--approved {
  background-color: #4caf50 !important;
}

.status-chip--rejected {
  background-color: #f44336 !important;
}
</style>
